/*** IMPORTS FROM imports-loader ***/
var define = false;

if (!('xl9' in window)) {
  window.xl9 = require('./main.js');
}




//////////////////
// WEBPACK FOOTER
// ./browser.js
// module id = 0
// module chunks = 0